import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';

import { UserData } from '../../../@core/data/users';
import { LayoutService } from '../../../@core/utils';
import { map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AuthService } from '../../../auth.service';
import { Router } from '@angular/router';
import { RoleService } from '../../../@core/services/role.service';
import { MasterService } from '../../../@core/services/master.service';
import { NbToastrService } from '@nebular/theme';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user: any;
  isNotificationsOpen = false;
  isNotificationsLoading = false;
  notifications: any[] = [];
  notificationCount: number = 0;
  userId: string = '';

  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'default';

  // userMenu = [ { title: 'Profile' }, { title: 'Log out' } ];
  userMenu = [
    { title: 'Profile', action: 'profile' },
    // { title: 'Log out', action: 'logout' }
  ];
  notificationMenu = [
    { title: 'No Notification'},
    // { title: 'Log out', action: 'logout' }
  ];
  constructor(private sidebarService: NbSidebarService,
              private menuService: NbMenuService,
              private themeService: NbThemeService,
              private userService: UserData,
              private layoutService: LayoutService,
              private breakpointService: NbMediaBreakpointsService,
              private authService: AuthService, 
              private router: Router,
              private roleService: RoleService,
              private masterService: MasterService,
              private toastrService: NbToastrService) {
  }

  ngOnInit() {
    this.currentTheme = this.themeService.currentTheme;
    this.userId = sessionStorage.getItem('user_id') || '';

    if (this.userId) {
      this.loadNotifications();
    }

    this.userService.getUsers()
      .pipe(takeUntil(this.destroy$))
      .subscribe((users: any) => this.user = users.nick);

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);
      
      setTimeout(() => {
        this.sidebarService.collapse('menu-sidebar');
      }, 0); 
  }

  onMenuItemClick(event: any) {
    debugger;
    if (event?.title === 'Log out') {
      this.logout();
    } else if (event?.title === 'Profile') {
      this.goToProfile();
    }
  }

  // logout() {
  //   this.authService.logout();
  //   this.router.navigate(['/login']); // Redirect to the login page
  // }
  logout() {
    // Clear session or token (if applicable)
    this.roleService.logout();   
    sessionStorage.removeItem('userToken');
    localStorage.removeItem('userToken');
    // sessionStorage.removeItem('role');
    sessionStorage.removeItem('role');
    sessionStorage.removeItem('user_id');
    localStorage.removeItem('user_id');
    localStorage.removeItem('role');
    sessionStorage.clear();
    // Navigate to login page (or any other page)
    this.router.navigate(['/login']);
  }

  goToProfile() {
    this.router.navigate(['/profile']); // Redirect to the profile page
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }
  openHelpLink() {
  window.open('https://sourcebuddy.idamtat.in/', '_blank');
}
isChatOpen = false;
chatText = '';
messages: any[] = [];

users = ['Admin', 'Engineer', 'Manager'];
filteredUsers: string[] = [];
showMentions = false;

toggleChat() {
  this.isChatOpen = !this.isChatOpen;
}

toggleNotifications() {
  this.isNotificationsOpen = !this.isNotificationsOpen;

  if (this.isNotificationsOpen) {
    this.loadNotifications();
  }
}

loadNotifications() {
  if (!this.userId) {
    this.notifications = [];
    this.notificationCount = 0;
    this.toastrService.warning('User id not found. Please login again.');
    return;
  }

  this.isNotificationsLoading = true;
  this.masterService.fetchNotifications(this.userId).subscribe({
    next: (response: any) => {
      this.notifications = this.extractNotifications(response);
      this.notificationCount = this.notifications.length;
      this.isNotificationsLoading = false;
    },
    error: (error) => {
      console.error('Error fetching notifications:', error);
      this.notifications = [];
      this.notificationCount = 0;
      this.isNotificationsLoading = false;
      this.toastrService.danger('Failed to fetch notifications.');
    },
  });
}

markNotificationAsRead(notification: any) {
  const notificationId = this.getNotificationId(notification);
  if (!notificationId) {
    return;
  }

  this.masterService.markNotificationRead(notificationId).subscribe({
    next: () => {
      notification.read = true;
      if (this.notificationCount > 0) {
        this.notificationCount = Math.max(0, this.notificationCount - 1);
      }
    },
    error: (error) => {
      console.error('Error marking notification read:', error);
      this.toastrService.danger('Failed to mark notification as read.');
    },
  });
}

private getNotificationId(notification: any): number | string | null {
  return notification?.notification_id || notification?.id || notification?.notificationId || notification?._id || null;
}

private extractNotifications(response: any): any[] {
  if (Array.isArray(response)) {
    return response;
  }

  if (Array.isArray(response?.data)) {
    return response.data;
  }

  if (Array.isArray(response?.notifications)) {
    return response.notifications;
  }

  if (Array.isArray(response?.result)) {
    return response.result;
  }

  return [];
}

getNotificationText(notification: any): string {
  return (
    notification?.message ||
    notification?.notification ||
    notification?.title ||
    notification?.description ||
    'Notification'
  );
}

getNotificationTime(notification: any): string {
  return (
    notification?.created_at ||
    notification?.createdAt ||
    notification?.date ||
    notification?.time ||
    ''
  );
}
selectedFile: File | null = null;

onFileUpload(event: any) {
  const file = event.target.files[0];
  if (file) {
    this.selectedFile = file;
  }
}

cancelFile() {
  this.selectedFile = null;
}


sendMessage() {
  if (!this.chatText.trim() && !this.selectedFile) return;

  this.messages.push({
    user: 'You',
    text: this.chatText,
    file: this.selectedFile ? this.selectedFile.name : null,
  });

  this.chatText = '';
  this.selectedFile = null;
}

onMentionSearch() {
  const match = this.chatText.match(/@(\w*)$/);
  if (match) {
    const search = match[1].toLowerCase();
    this.filteredUsers = this.users.filter(u =>
      u.toLowerCase().includes(search)
    );
    this.showMentions = this.filteredUsers.length > 0;
  } else {
    this.showMentions = false;
  }
}

selectMention(user: string) {
  this.chatText = this.chatText.replace(/@\w*$/, `@${user} `);
  this.showMentions = false;
}
autoGrow(event: any) {
  const textarea = event.target as HTMLTextAreaElement;
  textarea.style.height = 'auto';
  textarea.style.height = textarea.scrollHeight + 'px';
}




}
